export function getImageUrlFromImage(image) {
  if (!image) return null;
  return image.imageUrl || image.keyframeUrl || image.url || image.image_url || image.keyframe_url || null;
}

export function getAssetImageId(asset) {
  if (!asset) return null;
  return asset.imageId || asset.primaryImageId || asset.image_id || asset.primary_image_id || null;
}

export function resolveAssetImageUrl(asset, imagesById = {}) {
  const imageId = getAssetImageId(asset);
  return getImageUrlFromImage(imagesById?.[imageId]) || asset?.imageUrl || asset?.image_url || null;
}

export function resolveSecondaryAngles(asset, imagesById = {}) {
  const existingAngles = asset?.secondaryAngles || asset?.secondary_angles || null;
  const secondaryImageIds = asset?.secondaryImageIds || asset?.secondary_image_ids || null;
  if (!secondaryImageIds || typeof secondaryImageIds !== 'object') return existingAngles;

  const resolved = {};
  Object.entries(secondaryImageIds).forEach(([angle, imageId]) => {
    const url = getImageUrlFromImage(imagesById?.[imageId]);
    if (url) resolved[angle] = url;
  });
  return Object.keys(resolved).length > 0 ? resolved : existingAngles;
}

export function getAssetMediaType(asset) {
  if (!asset || typeof asset !== 'object') return 'image';
  return asset.mediaType || asset.media_type || 'image';
}

export function getAssetMediaUrl(asset) {
  const mediaType = getAssetMediaType(asset);
  if (mediaType === 'video') return asset?.videoUrl || asset?.video_url || null;
  if (mediaType === 'audio') return asset?.audioUrl || asset?.audio_url || null;
  return asset?.imageUrl || asset?.image_url || null;
}

export function normalizeAssetImageFields(asset, imagesById = {}) {
  if (!asset || typeof asset !== 'object') return asset;
  const mediaType = getAssetMediaType(asset);
  const imageId = mediaType === 'image' ? getAssetImageId(asset) : null;
  return {
    ...asset,
    mediaType,
    imageId: imageId || (mediaType === 'image' ? asset.imageId || null : null),
    primaryImageId: mediaType === 'image'
      ? (asset.primaryImageId || asset.primary_image_id || null)
      : null,
    primaryVideoId: asset.primaryVideoId || asset.primary_video_id || null,
    primaryAudioClipId: asset.primaryAudioClipId || asset.primary_audio_clip_id || null,
    secondaryImageIds: mediaType === 'image'
      ? (asset.secondaryImageIds || asset.secondary_image_ids || null)
      : null,
    imageUrl: mediaType === 'image' ? (resolveAssetImageUrl(asset, imagesById) || '') : '',
    videoUrl: asset.videoUrl || asset.video_url || null,
    audioUrl: asset.audioUrl || asset.audio_url || null,
    durationMs: asset.durationMs ?? asset.duration_ms ?? null,
    secondaryAngles: mediaType === 'image' ? resolveSecondaryAngles(asset, imagesById) : null,
    subAssets: Array.isArray(asset.subAssets)
      ? asset.subAssets.map((subAsset) => normalizeAssetImageFields(subAsset, imagesById))
      : asset.subAssets,
  };
}
